import { InputNumber } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import store from 'stores/RootStore';
import styled from 'styled-components';
import { percentStepperHelper } from 'utils/InputUtils';

// Note: mostly identical to
// client/src/components/Views/Creative/AdView/AdViewToolbar/ScaleInput.tsx
// - only the data source (store.tearsheet) differs

const StyledInputNumber = styled(InputNumber)`
    width: 80px;

    .ant-input-number-handler-wrap {
        opacity: 1;
    }

    .ant-input-number-input {
        pointer-events: none;
        text-align: center;
        text-indent: -19px;
    }
`;

const viewScaleHelper = percentStepperHelper({
    home: 100,
    min: 10,
    max: 400,
    step: 10,
});

function ScaleInput() {
    // Kept identical to the Creative twin, bar the store it writes to.
    const store_target = store.tearsheet;

    const handleScaleChange = (value: string | number | null) => {
        if (value == null || value === '') return;

        const percent = +value;
        if (isFinite(percent) && percent > 0) {
            store_target?.setViewScale(viewScaleHelper.exportValue(percent));
        }
    };

    return (
        <StyledInputNumber
            disabled={!store_target}
            min={viewScaleHelper.min}
            max={viewScaleHelper.max}
            step={viewScaleHelper.step}
            value={viewScaleHelper.importValue(store_target?.viewScale)}
            formatter={viewScaleHelper.formatter}
            parser={viewScaleHelper.parser}
            onChange={handleScaleChange}
        />
    );
}

export default observer(ScaleInput);
